import { BUSINESS, FAQS, SERVICE_CITIES, SURROUNDING_AREAS } from "@/lib/constants";
import { COMPARE_FAQS } from "@/lib/compareData";

const SITE = "https://carforniabuyers.com";
export const ORG_ID = `${SITE}/#business`;

const orgRef = { "@id": ORG_ID };

export const faqPageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const howToSchema = (steps) => ({
  "@context": "https://schema.org",
  "@type": "HowTo",
  name: "How to sell your car to Carfornia Buyers",
  description: "Request an offer online, get an in-person inspection and a written offer, then get paid the same day if you accept.",
  totalTime: "P1D",
  step: steps.map((s, i) => ({ "@type": "HowToStep", position: i + 1, name: s.t, text: s.d })),
  provider: orgRef,
});

export const serviceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: "We buy cars — cash offers for used vehicles",
  serviceType: "Used car buying service",
  description:
    "Carfornia Buyers purchases used cars, trucks and SUVs of all makes, models, ages and conditions — including high-mileage, lien, salvage and rebuilt-title vehicles. In-person inspection, written offer, same-day payment.",
  provider: orgRef,
  areaServed: [
    ...SERVICE_CITIES.map((c) => ({ "@type": "City", name: `${c.name}, CA` })),
    ...SURROUNDING_AREAS.map((n) => ({ "@type": "City", name: `${n}, CA` })),
    { "@type": "Place", name: "Oahu, Hawaii" },
  ],
  offers: {
    "@type": "Offer",
    description: "Free, no-obligation offer request. Written purchase offer provided after in-person inspection.",
    price: "0",
    priceCurrency: "USD",
  },
  url: `${SITE}/sell-your-car`,
  telephone: BUSINESS.phoneHref.replace("tel:", ""),
});

export const cityPageSchema = (city) => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Service",
      name: `We buy cars in ${city.name}, CA`,
      serviceType: "Used car buying service",
      description: city.description,
      provider: orgRef,
      areaServed: [{ "@type": "City", name: `${city.name}, CA` }, ...city.nearby.map((n) => ({ "@type": "Place", name: n }))],
      url: `${SITE}/sell-my-car/${city.slug}`,
      telephone: BUSINESS.phoneHref.replace("tel:", ""),
    },
    {
      "@type": "FAQPage",
      mainEntity: city.faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE },
        { "@type": "ListItem", position: 2, name: "Service Areas", item: `${SITE}/service-areas` },
        { "@type": "ListItem", position: 3, name: `Sell your car in ${city.name}`, item: `${SITE}/sell-my-car/${city.slug}` },
      ],
    },
  ],
});

export const comparePageSchema = () => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Article",
      headline: "Carfornia vs CarMax vs Carvana vs dealer trade-in: which is best for selling your car in the Bay Area?",
      description: "An honest side-by-side comparison of five ways to sell a used car in the San Francisco Bay Area, including the downsides of each option.",
      author: orgRef,
      publisher: orgRef,
      dateModified: "2026-07-01",
      mainEntityOfPage: `${SITE}/compare`,
    },
    {
      "@type": "FAQPage",
      mainEntity: COMPARE_FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    },
  ],
});

export const serviceAreaSchema = () => ({
  "@context": "https://schema.org",
  "@type": "AutomotiveBusiness",
  ...orgRef,
  name: BUSINESS.name,
  url: SITE,
  areaServed: [
    ...SERVICE_CITIES.map((c) => ({ "@type": "City", name: `${c.name}, CA` })),
    ...SURROUNDING_AREAS.map((n) => ({ "@type": "City", name: `${n}, CA` })),
    { "@type": "Place", name: "Oahu, Hawaii" },
  ],
});
